import _JSON$stringify from "/data/node/node-server/flyme-web-admin/node_modules/babel-runtime/core-js/json/stringify";
import _extends from "/data/node/node-server/flyme-web-admin/node_modules/babel-runtime/helpers/extends";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SCHEMA_VIDEO_CATE, SCHEMA_VIDEO_DATA } from "~/assets/js/api";
import { getHeaders } from "~/assets/js/utils";
import cookie from "~/assets/js/cookie";
import axios from "axios";
import md5 from "js-md5";
import sha1 from "sha1";

export default {
  name: "video-data",
  asyncData: function asyncData(_ref) {
    var route = _ref.route,
        redirect = _ref.redirect,
        store = _ref.store;

    return {
      uploader: null,
      webUploaderfile: null,
      showLoading: false,
      loadingText: "上传准备中",
      showButtons: false,
      isStop: false,
      limitSize: 200,
      videoNotChunked: false,

      reminder: "注：排序值决定数据排列，为0时排列最后",

      searchValue: "",
      statusArr: [{ label: "启用", value: 1 }, { label: "禁用", value: 0 }],
      pid: "",
      pidArr: [],

      tableData: [],
      count: 0,
      maxNum: 10,
      nowPageNum: 1,

      dataLoading: false,
      showDialog: false,
      isUpdate: false,
      updateId: "",

      form: {
        pid: "",
        title: "",
        img1: "",
        img2: "",
        img_mb: "",
        video: "",
        databh: "",
        nav_color: "#000000",
        sort: 0,
        status: 1 //默认为1，1表示启用，0表示禁用
      },
      rules: {
        pid: [{
          required: true,
          message: "请进行选择",
          trigger: "change"
        }],
        img1: [{
          required: true,
          message: "请上传图片",
          trigger: "change"
        }],
        img2: [{
          required: true,
          message: "请上传图片",
          trigger: "change"
        }],
        img_mb: [{
          required: true,
          message: "请上传图片",
          trigger: "change"
        }],
        video: [{
          required: true,
          message: "请上传视频",
          trigger: "change",
          type: "object"
        }],
        nav_color: [{
          required: true,
          message: "该值不能为空",
          trigger: "change"
        }],
        status: [{
          required: true,
          message: "请进行选择",
          trigger: "change",
          type: "number"
        }],
        title: [{
          required: true,
          message: "该值不能为空",
          trigger: "blur"
        }],
        sort: [{
          required: true,
          message: "该值不能为空",
          trigger: "blur",
          type: "number"
        }, { min: 0, message: '值不能小于0', trigger: 'blur', type: "number" }]
      },
      showImgDialog: false,
      currentImg: "",
      showVideoDialog: false,
      video: "",
      fileList: [],
      uploadVideoData: {},
      saveUnabled: false
    };
  },

  methods: {
    getPidArr: function getPidArr() {
      var _this2 = this;

      SCHEMA_VIDEO_CATE.select().then(function (res) {
        if (res.data.code === "000000") {
          var data = res.data.data.values,
              arr = [];
          for (var i = 0, len = data.length; i < len; i++) {
            arr.push({ label: data[i].cname, value: data[i].alias_name });
          }
          _this2.pid = arr[0].value;
          _this2.form.pid = arr[0].value;
          _this2.pidArr = arr;
          // console.log(`pidArr is ${JSON.stringify(this.pidArr)}`);
          _this2.getList();
        } else {
          var _this = _this2;
          _this2.$store.commit("openError", { obj: _this, res: res });
        }
      }, function (err) {
        var _this = _this2;
        _this2.$store.commit("openError", { obj: _this, res: err.response });
      });
    },
    pidChange: function pidChange() {
      this.form.pid = this.pid;
      this.getList();
    },
    pidFilter: function pidFilter(val) {
      for (var i = 0, len = this.pidArr.length; i < len; i++) {
        if (val === this.pidArr[i]["value"]) return this.utypeArr[i]["label"];
      }
    },
    statusFilter: function statusFilter(val) {
      for (var i = 0, len = this.statusArr.length; i < len; i++) {
        if (val === this.statusArr[i]["value"]) return this.statusArr[i]["label"];
      }
    },
    getList: function getList() {
      var _this3 = this;

      this.dataLoading = true;
      var where = { pid: this.pid };
      if (this.searchValue !== "") where.$or = [{ title: { $regex: this.searchValue } }];
      SCHEMA_VIDEO_DATA.select({
        where: where,
        headers: {
          "MZ-Query-NowPageNum": this.nowPageNum - 1,
          "MZ-Query-MaxNum": this.maxNum,
          "MZ-Query-Count": true,
          "MZ-Query-Order": "sort:-1",
          "MZ-Token": this.$store.state.userInfo.token,
          "MZ-Uid": this.$store.state.userInfo.uid
        }
      }).then(function (res) {
        if (res.data.code === "000000") {
          _this3.count = res.data.extra.count;
          _this3.tableData = res.data.data.values;
          _this3.dataLoading = false;
        } else {
          var _this = _this3;
          _this3.$store.commit("openError", { obj: _this, res: res });
        }
      }, function (err) {
        var _this = _this3;
        _this3.$store.commit("openError", { obj: _this, res: err.response });
      });
    },
    addData: function addData() {
      var _this4 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          SCHEMA_VIDEO_DATA.insert({
            object: _this4.form,
            headers: {
              "MZ-Token": _this4.$store.state.userInfo.token,
              "MZ-Uid": _this4.$store.state.userInfo.uid
            }
          }).then(function (res) {
            if (res.data.code === "000000") {
              _this4.$message({
                type: "success",
                message: "操作成功！"
              });
              _this4.getList();
            } else {
              var _this = _this4;
              _this4.$store.commit("openError", { obj: _this, res: res });
            }
            _this4.showDialog = false;
          }, function (err) {
            var _this = _this4;
            _this4.$store.commit("openError", {
              obj: _this,
              res: err.response
            });
            _this4.showDialog = false;
          });
        }
      });
    },
    updateData: function updateData() {
      var _this5 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          SCHEMA_VIDEO_DATA.update(_this5.updateId, {
            object: { update: { $set: _this5.form } },
            headers: {
              "MZ-Token": _this5.$store.state.userInfo.token,
              "MZ-Uid": _this5.$store.state.userInfo.uid
            }
          }).then(function (res) {
            if (res.data.code === "000000") {
              _this5.$message({
                type: "success",
                message: "操作成功！"
              });
              _this5.getList();
            } else {
              var _this = _this5;
              _this5.$store.commit("openError", { obj: _this, res: res });
            }
            _this5.showDialog = false;
            _this5.isUpdate = false;
            _this5.updateId = "";
          }, function (err) {
            var _this = _this5;
            _this5.$store.commit("openError", {
              obj: _this,
              res: err.response
            });
            _this5.showDialog = false;
            _this5.isUpdate = false;
            _this5.updateId = "";
          });
        }
      });
    },
    next: function next() {
      this.isUpdate ? this.updateData() : this.addData();
    },
    openUpdateDialog: function openUpdateDialog(row) {
      this.isUpdate = true;
      this.showDialog = true;
      this.updateId = row._id;
      var pid = row.pid,
          title = row.title,
          status = row.status,
          sort = row.sort,
          img1 = row.img1,
          img2 = row.img2,
          img_mb = row.img_mb,
          video = row.video,
          databh = row.databh,
          nav_color = row.nav_color;

      this.form = {
        pid: pid,
        title: title,
        status: status,
        sort: sort,
        img1: img1,
        img2: img2,
        img_mb: img_mb,
        video: video,
        databh: databh,
        nav_color: nav_color
      };
      if (this.form.video && this.form.video.url !== "") this.fileList.push(this.form.video);
    },
    deleteData: function deleteData(id) {
      var _this6 = this;

      this.$confirm("是否确定删除此项数据 ?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        SCHEMA_VIDEO_DATA.delete(id, {
          headers: {
            "MZ-Token": _this6.$store.state.userInfo.token,
            "MZ-Uid": _this6.$store.state.userInfo.uid
          }
        }).then(function (res) {
          if (res.data.code === "000000") {
            _this6.$message({
              type: "success",
              message: "操作成功！"
            });
            _this6.getList();
          } else {
            var _this = _this6;
            _this6.$store.commit("openError", { obj: _this, res: res });
          }
        }, function (err) {
          var _this = _this6;
          _this6.$store.commit("openError", { obj: _this, res: err.response });
        });
      });
    },
    handleCurrentChange: function handleCurrentChange() {
      this.getList();
    },
    openImgDialog: function openImgDialog(img) {
      this.currentImg = img;
      this.showImgDialog = true;
    },
    beforeImgUpload: function beforeImgUpload(file) {
      var isImg = file.type === "image/jpeg" || file.type === "image/png";
      if (!isImg) {
        this.$message.error("上传的图片只能是 JPG 或 PNG 格式!");
      }
      return isImg;
    },
    uploadImg1: function uploadImg1(obj) {
      this.uploadImg(obj, "img1");
    },
    uploadImg2: function uploadImg2(obj) {
      this.uploadImg(obj, "img2");
    },
    uploadImg3: function uploadImg3(obj) {
      this.uploadImg(obj, "img_mb");
    },
    uploadImg: function uploadImg(obj, key) {
      var _this7 = this;

      if (!this.beforeImgUpload(obj.file)) return;
      SCHEMA_VIDEO_DATA.uploadImg(obj.file, {
        "MZ-Token": this.$store.state.userInfo.token,
        "MZ-Uid": this.$store.state.userInfo.uid
      }).then(function (res) {
        if (res.data.code === "000000") {
          _this7.form[key] = res.data.data.images[0].securityUrl;
        } else {
          var _this = _this7;
          _this7.$store.commit("openError", { obj: _this, res: res });
        }
      }, function (err) {
        var _this = _this7;
        _this7.$store.commit("openError", { obj: _this, res: err.response });
      });
    },
    openVideoDialog: function openVideoDialog(video) {
      this.video = video.url;
      this.showVideoDialog = true;
    },
    beforeVideoUpload: function beforeVideoUpload(file) {
      if (file.type === "video/mp4" && file.size / 1024 / 1024 <= 20) {
        var headers = _extends({}, getHeaders(), {
          "MZ-Token": this.$store.state.userInfo.token,
          "MZ-Uid": this.$store.state.userInfo.uid
        });
        this.uploadVideoData["_headers"] = _JSON$stringify(headers);
        this.saveUnabled = true;
        return true;
      } else {
        this.$message.error("只能上传格式为mp4且小于20mb的视频");
        this.fileList = [];
        return false;
      }
    },
    handleChange: function handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    uploadVideoSuccess: function uploadVideoSuccess(res) {
      this.saveUnabled = false;
      if (res.code === "000000") {
        this.form.video = {
          url: res.data.files[0].url,
          name: res.data.files[0].originalFilename,
          status: "finished"
        };
      } else {
        this.$message.error("视频上传失败");
      }
    },
    removeVideo: function removeVideo(file, fileList) {
      this.form.video = "";
    },
    removeImg: function removeImg(key) {
      this.form[key] = "";
    },
    uploadVideoChunks: function uploadVideoChunks(obj) {
      if (obj.file.type === "video/mp4" && obj.file.size / 1024 / 1024 <= this.limitSize) {
        this.videoNotChunked = obj.file.size / 1024 / 1024 <= 5 ? true : false;
        if (!this.uploader) this.initWebUploader();
        this.webUploaderfile = this.initWebUploaderFile(obj.file);

        //beforeupload
        this.saveUnabled = true;
        this.showLoading = true;
        this.loadingText = "上传准备中，请耐心等待...";

        this.verifyVideoExist(this.webUploaderfile);
      } else {
        this.$message.error("\u53EA\u80FD\u4E0A\u4F20\u683C\u5F0F\u4E3A mp4 \u4E14\u5C0F\u4E8E " + this.limitSize + " mb \u7684\u89C6\u9891");
        if (this.fileList.length === 0) {
          this.fileList = [];
        } else {
          var fileList = this.fileList.pop();
          this.fileList.push(fileList);
        }
      }
    },
    verifyVideoExist: function verifyVideoExist(file) {
      // console.log(file.name);
      var that = this;
      var url = "http://flymeweb-admin.flyme.cn/v1.2/api/bigfile/quickUpload",
          headers = _extends({}, getHeaders(), {
        "MZ-Token": this.$store.state.userInfo.token,
        "MZ-Uid": this.$store.state.userInfo.uid
      }),
          bodies = void 0;
      this.uploader.addFiles(file);
      this.uploader.md5File(file).progress(function (percentage) {
        console.log("Percentage:", percentage);
      }).then(function (val) {
        console.log("md5 result:", val);
        bodies = {
          fileMD5: val,
          fileSHA1: sha1(val + file.size + file.type)
        };
        axios.post(url, {
          _headers: _JSON$stringify(headers),
          _bodies: _JSON$stringify(bodies)
        }).then(function (res) {
          if (res.data.code === "000000") {
            //文件在服务器上已存在
            that.form.video = {
              url: res.data.data.securityUrl,
              name: file.name,
              status: "finished"
            };
            that.fileList.length > 0 && that.fileList.pop();
            that.fileList.push(that.form.video);
            that.saveUnabled = false;
            that.showLoading = false;
            that.$message({
              showClose: true,
              type: "success",
              message: "视频已上传至服务器，应用视频需点击保存按钮"
            });
            that.uploader.reset();
          } else {
            that.startWebUpload(file, _extends({}, bodies, { fileSize: file.size }));
          }
        }, function (err) {
          var _that = that;
          that.$store.commit("openError", {
            obj: _that,
            res: err.response
          });
        });
      });
    },
    initWebUploader: function initWebUploader() {
      this.uploader = WebUploader.create({
        auto: false,
        swf: "/lib/webuploader/Uploader.swf",
        server: "http://flymeweb-admin.flyme.cn/v1.2/api/bigfile/upload",
        withCredentials: true,
        chunked: true,
        chunkSize: 5 * 1024 * 1024,
        chunkRetry: 3,
        threads: 3,
        duplicate: true,
        fileSizeLimit: this.limitSize * 1024 * 1024,
        fileSingleSizeLimit: this.limitSize * 1024 * 1024,
        accept: {
          // extensions: "mp4,mkv,avi,rmvb,wmv",
          // mineTypes: "audio/*,video/*"
          extensions: "mp4",
          mineTypes: "video/*"
        }
      });
    },
    initWebUploaderFile: function initWebUploaderFile(file) {
      return new WebUploader.File(new WebUploader.Lib.File(WebUploader.guid("rt_"), file));
    },
    startWebUpload: function startWebUpload(file, bodies) {
      this.webUploadStatus();
      this.uploader.options.formData._headers = _JSON$stringify(_extends({}, getHeaders(), {
        "MZ-Token": this.$store.state.userInfo.token,
        "MZ-Uid": this.$store.state.userInfo.uid
      }));
      this.uploader.options.formData._bodies = _JSON$stringify(bodies);
      if (this.videoNotChunked) {
        this.uploader.options.formData.chunk = 0;
        this.uploader.options.formData.chunks = 1;
      }
      this.uploader.upload();
    },
    webUploadStatus: function webUploadStatus() {
      var _this8 = this;

      this.uploader.on("uploadProgress", function (file, percentage) {
        var pct = Math.round(percentage * 100);
        _this8.loadingText = "\u6B63\u5728\u4E0A\u4F20\u4E2D\uFF0C\u5DF2\u5B8C\u6210 " + (pct + " %");
        if (pct == 100) {
          _this8.loadingText = "上传即将完成，请耐心等待...";
        }
      });
      this.uploader.on("uploadComplete", function (file) {
        console.log("uploadComplete, will be reset");
        _this8.uploader.reset();
      });
      this.uploader.on("uploadSuccess", function (file, res) {
        _this8.saveUnabled = false;
        _this8.showLoading = false;
        _this8.showButtons = false;

        if (res.code === "000000") {
          _this8.fileList.length > 0 && _this8.fileList.pop();
          _this8.form.video = {
            url: res.data.securityUrl,
            name: file.name,
            status: "finished"
          };
          _this8.fileList.push(_this8.form.video);
          _this8.$message({
            showClose: true,
            type: "success",
            message: "视频已上传至服务器，应用视频需点击保存按钮"
          });
        } else {
          _this8.$message.error("视频上传失败");
        }
        console.log("res is " + _JSON$stringify(res));
      });
      this.uploader.on("uploadError", function (file) {
        _this8.showLoading = false;
        _this8.showButtons = false;
        _this8.$alert("视频上传失败，请重试 ?", "提示", {
          confirmButtonText: "确定",
          callback: function callback(res) {
            _this8.saveUnabled = false;
            if (_this8.fileList.length === 0) {
              _this8.fileList = [];
            } else {
              var fileList = _this8.fileList.pop();
              _this8.fileList.push(fileList);
            }
          }
        });
      });
      this.uploader.on("startUpload", function () {
        _this8.showButtons = true;
        _this8.isStop = false;
      });
      this.uploader.on("stopUpload", function () {
        _this8.isStop = true;
      });
    },
    uploadCancel: function uploadCancel() {
      this.uploader.cancelFile(this.webUploaderfile);
      this.saveUnabled = false;
      this.showLoading = false;
      this.showButtons = false;
      if (this.fileList.length === 0) {
        this.fileList = [];
      } else {
        var fileList = this.fileList.pop();
        this.fileList.push(fileList);
      }
      this.$message({
        type: "warning",
        message: "已取消视频上传",
        showClose: true
      });
    }
  },
  mounted: function mounted() {
    this.getPidArr();
    console.log(WebUploader);
  },

  watch: {
    showVideoDialog: function showVideoDialog(val) {
      if (val === false) this.video = "";
    },
    showDialog: function showDialog(val) {
      if (val === false) {
        this.$refs.form.resetFields();
        this.isUpdate = false;
        this.updateId = "";
        this.fileList = [];
        this.form = {
          pid: this.pid,
          title: "",
          img1: "",
          img2: "",
          img_mb: "",
          nav_color: "#000000",
          video: "",
          databh: "",
          sort: 0,
          status: 1
        };
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/node/node-server/flyme-web-admin/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/index/videoData.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/node/node-server/flyme-web-admin/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/index/videoData.vue
// module chunks = 1